var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CrudList',{attrs:{"title":"Anuncios App","storeName":"App_ads","labelAddNew":"Agregar","sortable":"","canSearch":"","next-link":"/admin/spot_helps","breadcrumbs":[
      {
        text: 'Marketing y comunicación',
        disabled: false,
        href: '/admin/app_ads'
      },
      {
        text: 'Anuncios App',
        disabled: false,
        href: '#'
      }
    ]},scopedSlots:_vm._u([{key:"hidden",fn:function({ item }){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-switch',{ref:"hiddenSwitch",staticClass:"mt-n1 custom-purple",attrs:{"input-value":item.hidden,"color":"primary"},on:{"change":function($event){return _vm.updateHiddenStatus(item, $event)}}})],1)],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }